import {ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation} from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'arton-video',
  styles: [ require('./video.component.css') ],
  template: require('./video.component.html')
})
export class VideoComponent implements OnInit {

  ngOnInit(): void {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+video/video.component.ts